"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_components_1 = require("@securityproducts/core-components");
function DateFormatter(props) {
    console.warn("You are using the old date formatter. Please switch to the new version which takes displayUnit as the option");
    var format;
    if (props.customFormat) {
        format = props.customFormat;
    }
    else if (props.short) {
        format = "MMM d";
    }
    else {
        format = "MM/DD/yy";
    }
    var date = props.value;
    if (props.show24 && date.hour + date.minute + date.second === 0) {
        date = date.minus({ days: 1 });
    }
    var formatted = date.toFormat(format).toUpperCase();
    if (props.string) {
        return React.createElement(React.Fragment, null, formatted);
    }
    else {
        return React.createElement("span", { id: props.id }, formatted);
    }
}
exports.DateFormatter = DateFormatter;
var ChartDisplayRangeFormats;
(function (ChartDisplayRangeFormats) {
    ChartDisplayRangeFormats["DAYS"] = "MMM d";
    ChartDisplayRangeFormats["HOURS"] = "hh:mm a";
    ChartDisplayRangeFormats["MONTHS"] = "MMM yyyy";
})(ChartDisplayRangeFormats || (ChartDisplayRangeFormats = {}));
var TooltipDisplayRangeFormats;
(function (TooltipDisplayRangeFormats) {
    TooltipDisplayRangeFormats["DAYS"] = "MMM d, yyyy";
    TooltipDisplayRangeFormats["HOURS"] = "MMM d, yyyy hh:mm a";
    TooltipDisplayRangeFormats["MONTHS"] = "MMM yyyy";
})(TooltipDisplayRangeFormats || (TooltipDisplayRangeFormats = {}));
// TODO: remove old and rename this once all uses disappear
// export function newDateFormatter(
//     value: Spacetime,
//     range: DisplayRange,
//     context: FormatContext
// ): string {
//     const formats = context === "CHART" ? ChartDisplayRangeFormats : TooltipDisplayRangeFormats;
//     const format = formats[range];
//     const formatted = value.unixFmt(format);
//     return context === "CHART" ? formatted.toUpperCase() : formatted;
// }
function newDateFormatterLuxon(value, range, context, language) {
    var lang = language ? language : core_components_1.getBrowserLanguage();
    var formats = context === "CHART" ? ChartDisplayRangeFormats : TooltipDisplayRangeFormats;
    var format = formats[range];
    var formatted = value.setLocale(lang).toFormat(format);
    return context === "CHART" ? formatted.toUpperCase() : formatted;
}
exports.newDateFormatterLuxon = newDateFormatterLuxon;
